import $ from 'jquery'
import OLFormatGeoJSON from 'ol/format/GeoJSON'
import OLFormatGML from 'ol/format/GML'
import OLFormatWKT from 'ol/format/WKT'
import { fromExtent as OLPolygonFromExtent } from 'ol/geom/Polygon'
import { all as OLLoadingStrategyAll } from 'ol/loadingstrategy'
import OLSourceVector from 'ol/source/Vector'

import PoziAPIData from 'api/data'
import * as PoziUtils from 'api/utils'
import { setLayerLoadInProgress } from 'drawer/tabs/layers/actions'

import LoaderHandleGeoJSON, { LoaderFailed } from './LoaderHandleGeoJSON'

export default function LoaderGeneric(layer) {
  // console.debug('LoaderGeneric - loading geojson for layer: ' + layer.title)

  const geojsonSourceOpts = {
    format: new OLFormatGeoJSON(),
    crossOrigin: 'Anonymous',
    loader: function (extent, resolution, projection, success, failure) {
      // Make a copy to avoid corrupting the base config.
      const spatial = $.extend({}, layer.config.spatial)
      // setBBOXExtents(extent, spatial)
      let url = PoziUtils.getLayerUrl(layer)

      // Replace any special props like $wkt and $gml with values representing the world extent
      // This is to accommodate situations with EXP_FILTER params that were designed for fetching the
      // layer as a child dataset but are not applicable when visualising the layer itself.
      // They can contain variables like [$wkt] or [$gml]

      const specialProps = getSpecialProps()
      url = PoziUtils.replaceUrlVariablesWithPropsValues(url, specialProps)

      // const bReplacementNotDone = (url.indexOf('[$cqlgeometry]') !== -1)

      if (!url) {
        console.log('Invalid url for layer', layer.titleid)

        return LoaderFailed(layer, 'Replacement variables not done', failure)
      }

      // In 'LoaderHandleGeoJSON' we will set layer load done/failed
      window.store.dispatch(setLayerLoadInProgress(layer.titleid))

      // Fetching the features in the current bounding box
      PoziAPIData()
        .ajax({
          url,
          error: function (jqXHR, textStatus, errorThrown) {
            console.log('LoaderGeneric - loaderFailed url', layer.titleid, url)

            LoaderFailed(layer, errorThrown, failure)
          },
          success: function (geojson, textStatus, jqXHR) {
            // Handle ESRI's error responses within the JSON(!) with a 200 OK response...
            if (geojson?.error) {
              const error = geojson.error
              const { code, details = [], message = '' } = geojson.error || {}

              const fullErrorMessage = [code, message, ...details].filter(Boolean).join(', ')

              LoaderFailed(layer, fullErrorMessage, failure)

              // Continue if the response has features despite giving an error
              if (!geojson?.features) {
                return
              }
            }

            LoaderHandleGeoJSON(geojson, projection, geojsonSource, layer, success)
          }
        })
        .catch(function (error) {
          console.log('LoaderGeneric - unexpected error', layer.titleid, error)

          LoaderFailed(layer, 'Unexpected error', failure)
        })
    },
    strategy: OLLoadingStrategyAll
    // projection: 'EPSG:3857'
  }

  const geojsonSource = new OLSourceVector(geojsonSourceOpts)

  return geojsonSource
}

/** This function creates an object with special props like $wkt and $gml */
const getSpecialProps = () => {
  const worldExtent = [-180, -90, 180, 90]

  const worldExtentPolygon = OLPolygonFromExtent(worldExtent)

  const worldExtentWkt = new OLFormatWKT().writeGeometry(worldExtentPolygon)
  const worldExtentGml = new OLFormatGML().writeGeometry(worldExtentPolygon)

  const specialProps = {
    $gml: worldExtentGml,
    $wkt: worldExtentWkt
  }

  // console.debug('getSpecialProps - props', specialProps)

  return specialProps
}

/**
 * Updates <BBOX> string in either the spatial url and/or params with a buffered extent.
 * Must run before addParamsToURL because that function urlencodes the strings.
 */
// var setBBOXExtents = function (extent, spatial) {
//   // Buffering the extent by 5000m in all directions
//   const bufferMeters = spatial.buffer || 5000
//   // This should load the features loaded in the tabs (i.e. 3 closest) in most cases
//   const bufferedExtent = $.map(extent, function (val, idx) {
//     return idx % 4 < 2 ? val - bufferMeters : val + bufferMeters
//   })

//   // Substitution of BBOX
//   if (spatial && spatial.params) {
//     for (const key in Object.keys(spatial.params)) {
//       const value = spatial.params[key]
//       if (!value || typeof value !== 'string') {
//         continue
//       }
//       if (includes(value, '<BBOX>')) {
//         spatial.params[key] = value.replace(/<BBOX>/g, bufferedExtent.join(','))
//       }
//     }
//   }
//   if (spatial && spatial.url && typeof spatial.url === 'string') {
//     if (includes(spatial.url, '<BBOX>')) {
//       spatial.url = spatial.url.replace(/<BBOX>/g, bufferedExtent.join(','))
//     }
//   }
// }

// export const addParamsToURL = function (spatial) {
//   let url = ''
//   // Add base url
//   if (spatial?.url) {
//     url = spatial.url
//   } else {
//     console.log('No parameter spatial.url, check config.', spatial)
//   }

//   if (isNil(url) || url === '') {
//     return url
//   }

//   // Add params
//   if (spatial && spatial.params) {
//     const urlParams = $.extend({}, spatial.params)
//     // If the configured url already has an "?" then append query string parameters using & to start
//     if (url.indexOf('?') > -1) {
//       url = url + (Object.keys(urlParams).length ? '&' + PoziUtils.paramsToUrl(urlParams) : '')
//     } else {
//       url = url + (Object.keys(urlParams).length ? '?' + PoziUtils.paramsToUrl(urlParams) : '')
//     }
//   }

//   // NOTE: If you add anything here also add it to defaultExcludeProperties in AddDefaultExcludes.js
//   // Add specific Url properties
//   /*
//   url = replaceURLVariable(url, 'x')
//   url = replaceURLVariable(url, 'y')
//   url = replaceURLVariable(url, 'z')
//   */
//   url = replaceURLVariable(url, 'sectoken')
//   return url
// }

// urlVariableName: e.g. sectoken
// const replaceURLVariableFromModel = (url, urlVariableName) => {
//   if (!urlVariableName) {
//     return url
//   }

//   const replaceString = Model.getState(urlVariableName, null)
//   if (isNil(replaceString)) {
//     return url
//   }

//   const findString = '[$' + urlVariableName + ']'
//   url = url.replace(findString, replaceString)

//   return url
// }
